<!-- 
    描述：审核待办  -- 专家 -- 工作经验
    时间：2020/10/30
    Created by zl
-->
<template>
	<div>
		<el-form v-if="bankInfo.length >= 1"
				 label-width="140px"
				 size="small">
			<el-row>
				<div class="item-box clearfix"
					 v-for="(itme, index) in bankInfo"
					 :key="'bankInfo' + index">
					<el-row>
						<el-col :span="11">
							<el-form-item label="时间：">
								<el-col :span="11">
									<el-date-picker v-model="itme.startDate"
													type="date"
													disabled></el-date-picker>
								</el-col>
								<el-col :span="2"
										class="text-center">到</el-col>
								<el-col :span="11">
									<el-date-picker v-model="itme.endDate"
													type="date"
													disabled></el-date-picker>
								</el-col>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="11">
							<el-form-item label="公司：">
								<el-input v-model="itme.company"
										  disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item label="公司性质：">
								<el-input v-model="itme.typeName"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="11">
							<el-form-item label="职能：">
								<el-input v-model="itme.functions"
										  disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item label="行业：">
								<el-input v-model="itme.industry"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="11">
							<el-form-item label="职位：">
								<el-input v-model="itme.postion"
										  disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="11"
								:offset="1">
							<el-form-item label="岗位：">
								<el-input v-model="itme.post"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label="工作描述：">
								<el-input v-model="itme.description"
										  type="textarea"
										  :rows="5"
										  disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="工作类型：">
								<div class="flex isFull">
									<div :class="{ active: itme.jobType == '0' }">
										兼职
									</div>
									<div :class="{ active: itme.jobType == '1' }">
										全职
									</div>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-row>
		</el-form>
		<div v-else
			 class="text-center">暂无数据</div>
	</div>
</template>
<script>
export default {
	props: {
		bankInfo: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {}
	},
	methods: {},
}
</script>
<style lang="less" scoped>
.isFull {
	margin-top: 3px;
	width: 136px;
	height: 32px;
	line-height: 32px;
	border: 1px solid #e6a23c;
	border-radius: 3px 0px 0px 3px;
	div {
		flex: 1;
		text-align: center;
		color: #e6a23c;
		cursor: default;
	}
	.active {
		background-color: #e6a23c;
		color: #fff;
	}
}
</style>
